// extracted by mini-css-extract-plugin
module.exports = {"root":"ScoreBadge_root__2ypaM","total":"ScoreBadge_total__1vdEC","sufficient":"ScoreBadge_sufficient__3XpmY","insufficient":"ScoreBadge_insufficient__1ikJM"};